
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_1kj8n_189",
  "result-state": "awsui_result-state_11huc_1kj8n_203",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_1kj8n_1",
  "root": "awsui_root_11huc_1kj8n_225",
  "with-result-button": "awsui_with-result-button_11huc_1kj8n_257",
  "result-text": "awsui_result-text_11huc_1kj8n_261",
  "result-container-error": "awsui_result-container-error_11huc_1kj8n_265",
  "result-container-success": "awsui_result-container-success_11huc_1kj8n_265",
  "result-button": "awsui_result-button_11huc_1kj8n_269",
  "word-wrap": "awsui_word-wrap_11huc_1kj8n_275",
  "label-flash": "awsui_label-flash_11huc_1kj8n_280",
  "label-key-value": "awsui_label-key-value_11huc_1kj8n_284",
  "flash": "awsui_flash_11huc_1kj8n_292",
  "progress-container": "awsui_progress-container_11huc_1kj8n_296",
  "percentage-container": "awsui_percentage-container_11huc_1kj8n_303",
  "percentage": "awsui_percentage_11huc_1kj8n_303",
  "complete": "awsui_complete_11huc_1kj8n_349",
  "progress-in-flash": "awsui_progress-in-flash_11huc_1kj8n_362",
  "additional-info": "awsui_additional-info_11huc_1kj8n_375"
};
  